import { connect } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
import { actions as modalActions } from '../../Modals';
var mapStateToProps = function (state, ownProps) { return ({
    isCreator: getIsCurrentUserAuthorOf(state, ownProps.deviation),
}); };
var mapDispatchToProps = function (dispatch, ownProps) { return ({
    openListingModal: function (deviation) {
        dispatch(modalActions.pushDasModal('listing', deviation));
    },
    openBidModal: function (deviation) {
        dispatch(modalActions.pushDasModal('bid', deviation));
    },
    openManageModal: function (deviation) {
        dispatch(modalActions.pushDasModal('manage', deviation));
    },
}); };
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=Button.container.js.map